import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptoV2Service {
  private readonly encryptionKey: string;
  private readonly ivSize: number = 16; // 128 bits

  constructor() {
    // Chave deve ter 32 caracteres para AES-256
    this.encryptionKey = "7mHwjUX0ksK18RsEpQyIfXyrUc0KFzQs";
                       // 12345678901234567890123456789012
  }

  encryptData(plainText: string): string {
    try {
      // Garante que a chave tenha exatamente 256 bits (32 caracteres)
      const key = CryptoJS.enc.Utf8.parse(this.encryptionKey);
      const iv = CryptoJS.lib.WordArray.random(this.ivSize);
      
      const encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return iv.toString(CryptoJS.enc.Base64) + ':' + encrypted.toString();
    } catch (error) {
      console.error('Encryption error:', error);
      throw new Error('Failed to encrypt data');
    }
  }

  decryptData(cipherText: string): string {
    try {
      if (!cipherText.includes(':')) {
        throw new Error('Invalid cipher text format');
      }

      const [ivBase64, encryptedData] = cipherText.split(':');
      const key = CryptoJS.enc.Utf8.parse(this.encryptionKey);
      const iv = CryptoJS.enc.Base64.parse(ivBase64);

      const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('Decryption error:', error);
      throw new Error('Failed to decrypt data');
    }
  }
}
